import { Injectable } from '@angular/core';
import {BackendService} from "./backend.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {ResponseDto} from "../dto/response.dto";

@Injectable({
  providedIn: 'root'
})
export class ValueService {

    private urlPrefix = '/api/value';

    constructor(private backend: BackendService) {}
    // Registrar características de la propiedad
    registerFeatureValues(propertyId: any, features: any[]): Observable<any> {
        const url = `${this.urlPrefix}/property/${propertyId}`;
        return this.backend.post(url, features).pipe(
            map(response => response)
        );
    }

    updateFeatureValue(valueId: number, value: any): Observable<any> {
        const url = `${this.urlPrefix}/${valueId}`;
        return this.backend.put(url, { data: String(value ?? '') }).pipe(
            map(response => response)
        );
    }

}
